module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<!-- 酒店信息 -->\r\n<div class="hotel-detail-info-inner">\r\n    <div class="hdi-head">\r\n        <h1 class="hdi-hotel-name1">\r\n			<span class="hdi-hotel-name">' +
((__t = ( o.infoName )) == null ? '' : __t) +
'</span>\r\n			<span class="hdi-hotel-name2">' +
((__t = ( o.enName || '' )) == null ? '' : __t) +
'</span>\r\n			';
 if(o.displayFlag) { ;
__p += '\r\n				<i class="hli-icon' +
((__t = ( o.displayFlag === '1' ? ' icon-jinpai' : o.displayFlag === '2' ? ' icon-tuiguang' : '' )) == null ? '' : __t) +
' "></i>\r\n			';
 } ;
__p += '\r\n			<span class="hdi-level-name">\r\n			' +
((__t = ( 
				~('50,55'.indexOf( o.star )) ? '豪华型' :
				~('40,45'.indexOf( o.star )) ? '高档型' :
				~('30,35'.indexOf( o.star )) ? '舒适型' : '经济型'
			)) == null ? '' : __t) +
'\r\n			</span>\r\n			\r\n			<span class="hdi-icon-star"></span>\r\n			<span class="hdi-icon-star"></span>\r\n			';
 if(~('50,55'.indexOf( o.star ))) { ;
__p += '\r\n				<span class="hdi-icon-star"></span>\r\n				<span class="hdi-icon-star"></span>\r\n				<span class="hdi-icon-star"></span>\r\n			';
 } else if(~('40,45'.indexOf( o.star ))) { ;
__p += '\r\n				<span class="hdi-icon-star"></span>\r\n				<span class="hdi-icon-star"></span>\r\n			';
 } else if(~('30,35'.indexOf( o.star ))) { ;
__p += '\r\n				<span class="hdi-icon-star"></span>\r\n			';
 } ;
__p += '\r\n		</h1>\r\n		\r\n		<div class="hdi-location">\r\n			<i class="iconfont icon-location1"></i>\r\n			<label>地址：</label>\r\n			<a title="map" class="hdi-open-map" href="#hotelMap" data-link="';
 if (o.countryType==0) {;
__p += '/biz/hotel/foreignhotel/baiduMap.jsp';
 }else{ ;
__p += '/biz/hotel/foreignhotel/googleMap.jsp';
 } ;
__p += '?lon=' +
((__t = ( o.longitude || 0 )) == null ? '' : __t) +
'&amp;lat=' +
((__t = ( o.latitude || 0 )) == null ? '' : __t) +
'&amp;_location=' +
((__t = ( encodeURI(encodeURI(o.address.replace(/[： 。，！、:.!,]+$/g,''))) )) == null ? '' : __t) +
'&amp;_title=' +
((__t = ( encodeURI(encodeURI(o.infoName)) )) == null ? '' : __t) +
'">\r\n				<span class="hdi-location-text">' +
((__t = ( o.address.replace(/[： 。，！、:.!,]+$/g,'') || '' )) == null ? '' : __t) +
'</span>\r\n			</a>\r\n		</div>\r\n		\r\n		<div class="hdi-lowest-wrap">\r\n			<div class="hdi-gz-wrap">\r\n				<div class="hdi-gz-inner ' +
((__t = ( (o.hasOwnProperty('isMyFavorite') && o.isMyFavorite === 1) ? 'icon-gz-on' : 'icon-gz-off' )) == null ? '' : __t) +
'" data-hotelid="' +
((__t = ( o.infoId )) == null ? '' : __t) +
'">\r\n					';
 if (o.hasOwnProperty('isMyFavorite') && o.isMyFavorite === 1){ ;
__p += '\r\n						<i class="iconfont icon-favorite-fill"></i>\r\n						<span class="icon-gz-on-tips">已收藏</span>\r\n					';
 }else{ ;
__p += '\r\n						<i class="iconfont icon-favorite"></i>\r\n						<span class="icon-gz-on-tips">未收藏</span>\r\n					';
 } ;
__p += '\r\n				</div>\r\n			</div>\r\n		</div>\r\n    </div>\r\n\r\n    <div class="hdi-body">\r\n		<div class="hdi-img-outer">\r\n			<div class="hdi-img-wrap-big">\r\n				<div class="hdi-scroll-btn left disabled">\r\n					<i class="iconfont icon-left2"></i>\r\n				</div>\r\n\r\n				<img class="hdi-img-source" src="' +
((__t = ( o.picSrc.replace(/\/common\/images\/nopic.png/, 'https://qnb.oss-cn-shenzhen.aliyuncs.com/real_1560999493874.png" style="width: 50%;margin: 70px 0 0 137px;') )) == null ? '' : __t) +
'" />\r\n				\r\n				<div class="hdi-scroll-btn right">\r\n					<i class="iconfont icon-right2"></i>\r\n				</div>\r\n			</div>\r\n			<div class="hdi-img-wrap-small">\r\n				<div class="hdi-img-scroll scroll-up disabled">\r\n					<i class="hli-icon"></i>\r\n				</div>\r\n				\r\n				<ul class="hdi-img-small-list">\r\n					';
 for(var i = 0; i < o.picList.length; i++){ var p = o.picList[i]; ;
__p += '\r\n					<li class="hdi-img-small-item ' +
((__t = ( i === 0 ? 'active' : '')) == null ? '' : __t) +
'" data-index="' +
((__t = ( i )) == null ? '' : __t) +
'">\r\n						<img class="hide-img-thumb" src="' +
((__t = ( p.replace(/\/common\/images\/nopic.png/, 'https://qnb.oss-cn-shenzhen.aliyuncs.com/real_1560999493874.png" style="width: 50%;margin: 20px 0 0 32px;') )) == null ? '' : __t) +
'" />\r\n					</li>\r\n					';
 } ;
__p += '\r\n				</ul>\r\n\r\n				<div class="hdi-img-scroll scroll-down">\r\n					<i class="hli-icon"></i>\r\n				</div>\r\n			</div>\r\n		</div>\r\n		<div class="hdi-brief-wrap">\r\n			<ul class="hdi-brief-list">\r\n				<li class="hdi-brief-item">\r\n					<p class="hdi-brief-item-title">酒店简介</p>\r\n					<div id="hotel-introduction" class="hdi-brief-item-content" data-content="' +
((__t = ( o.infoDesc )) == null ? '' : __t) +
'">\r\n						';
 if(o.infoDesc && o.infoDesc.length > 45){ ;
__p += '\r\n							<span>' +
((__t = ( o.infoDesc.substring(0,45) )) == null ? '' : __t) +
'......</span>\r\n							<a href="javascipt:void(0);" class="hdi-brief-view-detail">[查看详情]</a>\r\n						';
 } else { ;
__p += '\r\n							<span>' +
((__t = ( o.infoDesc || '' )) == null ? '' : __t) +
'</span>\r\n						';
 } ;
__p += '\r\n					</div>\r\n					<p>联系方式：' +
((__t = ( o.bookingPhone || '' )) == null ? '' : __t) +
'</p>\r\n				</li>\r\n				<li class="hdi-brief-item">\r\n					<p class="hdi-brief-item-title">特别提示</p>\r\n					<div class="hdi-brief-item-content" data-content="' +
((__t = ( o.indicate )) == null ? '' : __t) +
'">\r\n						';
 if(o.indicate && o.indicate.length > 45){ ;
__p += '\r\n							<span>' +
((__t = ( o.indicate.substring(0,45) )) == null ? '' : __t) +
'......</span>\r\n							<a href="javascipt:void(0);" class="hdi-brief-view-detail">[查看详情]</a>\r\n						';
 } else { ;
__p += '\r\n							<span>' +
((__t = ( o.indicate || '无' )) == null ? '' : __t) +
'</span>\r\n						';
 } ;
__p += '\r\n					</div>\r\n				</li>\r\n			</ul>\r\n\r\n			<p id="mapCon1" style="height: 210px;margin-top: 8px;"></p>\r\n		</div>\r\n    </div>\r\n</div>\r\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/js/hotelDetail/templates/hotelInfoTmpl.ejs
// module id = 335
// module chunks = 6